import { render, staticRenderFns } from "./FormTextAreaDefault.vue?vue&type=template&id=49980abd"
import script from "./FormTextAreaDefault.vue?vue&type=script&lang=js"
export * from "./FormTextAreaDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports